import { render } from "./BlogPreview.vue?vue&type=template&id=05b52d7c&scoped=true"
import script from "./BlogPreview.vue?vue&type=script&lang=js"
export * from "./BlogPreview.vue?vue&type=script&lang=js"

import "./BlogPreview.vue?vue&type=style&index=0&id=05b52d7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b52d7c"]])

export default __exports__